<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-right>
      <vdr-action-bar-items
        [locationId]="'package-summary'"
      ></vdr-action-bar-items>
      
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<vdr-split-view
  [rightPanelOpen]="activeRowId$ | async"
  (closeClicked)="closeContents()"
>
  <ng-template vdrSplitViewLeft>
    <custom-data-table
      class="mt-2"
      id="package-summary-table"
      [items]="items$ | async"
      [itemsPerPage]="itemsPerPage$ | async"
      [totalItems]="totalItems$ | async"
      [currentPage]="currentPage$ | async"
      [filters]="filters"
      [expandedRowIndex]="expandedRowIndex"
      (pageChange)="setPageNumber($event)"
      (itemsPerPageChange)="setItemsPerPage($event)"
    >
      <vdr-dt2-search
        [searchTermControl]="searchTermControl"
        [searchTermPlaceholder]="'Search by batch number'"
      ></vdr-dt2-search>

      <vdr-dt2-column
        [heading]="'common.id' | translate"
        id="id"
        [hiddenByDefault]="false"
        [sort]="sorts.get('id')"
      >
        <ng-template let-package="item">
          {{ package.id }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'Order'"
        id="order"
        [hiddenByDefault]="false"
        [sort]="false"
      >
        <ng-template let-package="item">
          <a
            class="button-ghost"
            [routerLink]="['/orders', package.orderId]"
          >
            <span>{{ package.order?.code || 'N/A' }}</span>
            <clr-icon shape="arrow right"></clr-icon>
          </a>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'package.batch-number' | translate"
        id="batch-number"
        [hiddenByDefault]="false"
        [sort]="false"
      >
        <ng-template let-package="item">
          <vdr-chip colorFrom="{{ package.batchNumber ? package.batchNumber : 'N/A' }}">
            {{ package.batchNumber || 'N/A' }}
          </vdr-chip>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'package.package-status' | translate"
        id="status"
        [hiddenByDefault]="false"
        [sort]="sorts.get('status')"
      >
        <ng-template let-package="item">
          <vdr-chip [colorType]="getStatusColor(package.status)">
            {{ package.status || 'Unknown' }}
          </vdr-chip>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.total-quantity' | translate"
        id="total-quantity"
        [hiddenByDefault]="false"
        [sort]="sorts.get('totalQuantity')"
      >
        <ng-template let-package="item">
          {{ package.totalQuantity || 0 }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'package.estimated-weight' | translate"
        id="estimated-weight"
        [hiddenByDefault]="false"
        [sort]="sorts.get('estimatedWeight')"
      >
        <ng-template let-package="item">
          {{ package.estimatedWeight || 'N/A' }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.created-at' | translate"
        id="created-at"
        [hiddenByDefault]="false"
        [sort]="sorts.get('createdAt')"
      >
        <ng-template let-package="item">
          {{ package.createdAt | localeDate : "short" }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'Detail'"
        id="detail"
        [hiddenByDefault]="false"
      >
        <ng-template let-package="item">
          <a
            class="button-ghost"
            [routerLink]="[package.status === 'Packed' ? '/extensions/package-waiting' : '/extensions/package-pushed', package.id]"
          >
            <span>{{ "package.view-detail" | translate }}</span>
            <clr-icon shape="arrow right"></clr-icon>
          </a>
        </ng-template>
      </vdr-dt2-column>
    </custom-data-table>
  </ng-template>
  <ng-template vdrSplitViewRight [splitViewTitle]="'  '">
    <h1>Package Details</h1>
    <p>Select a package to view details</p>
  </ng-template>
</vdr-split-view>
